module.exports = __webpack_public_path__ + "6e2db8d52360629b7bac9c6db189355c.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-creators.png
// module id = 3224
// module chunks = 69